import React, { useState, useCallback, useRef } from 'react'
import BPAlert from '../components/BPAlert'

export const AlertContext = React.createContext({
  alert: {},
  setAlert: () => {},
  openAlert: () => {},
  closeAlert: () => {},
  cancelAlert: () => {},
  submitAlert: () => {}
})

export const AlertProvider = ({ children, rest }) => {
  const alertOptions = { type: 'error', isOpen: false, message: '', isConfirmOpen: false, ...rest }
  const [alert, setAlert] = useState(alertOptions)
  const resolver = useRef()

  const closeAlert = () => setAlert({ isOpen: false })
  const cancelAlert = () => {
    // resolver.current && resolver.current(false)
    setAlert({ isOpen: false, isConfirmOpen: false })
  }
  const openAlert = (alertType, isOpen, message, isConfirmOpen, htmlContent, alertOptions) => {
    if (isOpen || isConfirmOpen) setAlert({ type: alertType, isOpen: isOpen, message: message, isConfirmOpen: isConfirmOpen, htmlContent: htmlContent, ...alertOptions })
    return new Promise(function (resolve) {
      resolver.current = resolve
    })
  }
  const handleSubmit = () => {
    resolver.current && resolver.current(true)
    setAlert({ isOpen: false, isConfirmOpen: false })
  }
  const value = {
    alert,
    setAlert,
    openAlert: useCallback((alertType, isOpen, message, isConfirmOpen, htmlContent, alertOptions) => openAlert(alertType, isOpen, message, isConfirmOpen, htmlContent, alertOptions), []),
    closeAlert: useCallback(() => closeAlert(), []),
    cancelAlert: useCallback(() => cancelAlert(), []),
    submitAlert: useCallback(() => handleSubmit(), [])
  }

  return (
    <AlertContext.Provider value={value}>
      {children}
      {(alert.isOpen && alert.isOpen !== undefined && alert.message !== undefined) && (
        <BPAlert
          type={alert.type} message={alert.message} isOpen={alert.isOpen} onClose={closeAlert} htmlContent={alert.htmlContent}
        />)}
      {(alert.isConfirmOpen && alert.isConfirmOpen !== undefined && alert.message !== undefined) && (
        <BPAlert
          type={alert.type} message={alert.message} isOpen={alert.isConfirmOpen}
          onClose={closeAlert} onAccept={handleSubmit} onCancel={cancelAlert} htmlContent={alert.htmlContent} cancelButtonText={alert.cancelButtonText}
          confirmButtonText={alert.acceptButtonText}
        />)}
    </AlertContext.Provider>
  )
}
